import { Component, Injector, Input, ViewEncapsulation } from '@angular/core';
import { Banner } from '@shopping-angular-components/flex-safe-stay-banners-container/lib/models/banner.model';
import { AbstractComponent } from '../abstract.component';
import { Module } from 'projects/common/model/ModuleModel';

export interface FlexSafeBannerData {
  show_flexible_booking_banner: boolean;
  show_safe_stay_banner: boolean;
  safe_stay_content: Banner;
  flexible_booking_content: Banner;
}
@Component({
  selector: 'flex-safe-stay-banner-wrapper',
  template: `
    <div *ngIf="module.data" class="flex-safe-stay-banner-container">
      <flex-safe-stay-banners-container
        product="nymeria-gui"
        [flow]="flow"
        [showFlexibleBookingBanner]="module.data.show_flexible_booking_banner"
        [showSafeStayBanner]="module.data.show_safe_stay_banner"
        [safeStayContent]="module.data.safe_stay_content"
        [flexibleBookingContent]="module.data.flexible_booking_content"
      ></flex-safe-stay-banners-container>
    </div>
  `,
  styleUrls: ['./flex-safe-stay-banner-wrapper.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FlexSafeStayBannerWrapperComponent extends AbstractComponent {

  @Input() override module: Module<FlexSafeBannerData>;

  constructor(injector: Injector) {
    super(injector);
   }

  getModuleId(): string {
    return "FlexSafeStayBannerModule";
  }

}
